import {
  hasEssentialsAccess,
  hasMyIncidentsAccess,
  hasPowerOutageAccess,
} from "@/services/user/user.service";

export const POINTS_SECTIONS_ENABLED_DEFAULT = false;
export const OVERLAYS_SECTIONS_ENABLED_DEFAULT = false;
export const EXTERNAL_SECTIONS_ENABLED_DEFAULT = false;

export const POINTS_SECTION_SEARCHES = "searches";
export const POINTS_SECTION_HOTSPOTS = "hotspots";
export const POINTS_SECTION_MY_INCIDENTS = "my_incidents";
export const POINTS_SECTION_ASSETS = "assets";

export const MAP_LAYER_METADATA_SEARCHES = "seerist-points-searches";
export const MAP_LAYER_METADATA_HOTSPOTS = "seerist-points-hotspots";
export const MAP_LAYER_METADATA_MY_INCIDENTS = "seerist-points-incidents";
export const MAP_LAYER_METADATA_ASSETS = "seerist-points-assets";

export const OVERLAYS_SECTION_RISK_RATINGS = "risk_ratings";
export const OVERLAYS_SECTION_PULSE = "pulse";
export const OVERLAYS_SECTION_POWER_OUTAGE = "power_outage";

export const MAP_LAYER_METADATA_RISK_RATINGS = "seerist-overlays-risk-ratings";
export const MAP_LAYER_METADATA_PULSE = "seerist-overlays-pulse";
export const MAP_LAYER_METADATA_POWER_OUTAGE = "seerist-overlays-power-outage";

export const MAP_LAYER_METADATA_EXTERNAL = "seerist-external";

// Approx bounds for lower 48 states; [lng, lat] format
export const POWER_OUTAGE_US48_BOUNDS = [
  [-147.9083, 20.2446],
  [-44.832, 52.9463],
];

let pointsSections = [
  {
    id: POINTS_SECTION_SEARCHES,
    title: "Search Results",
    visible: false,
    visibleDefault: true,
    mapLayerMetadata: MAP_LAYER_METADATA_SEARCHES,
    filterLinkPanel: undefined,
  },
  {
    id: POINTS_SECTION_HOTSPOTS,
    title: "Hotspots",
    visible: false,
    visibleDefault: false,
    contentComp: "MapControlsPointsHotspots",
    mapLayerMetadata: MAP_LAYER_METADATA_HOTSPOTS,
    filterLinkPanel: undefined,
  },
];
let overlaysSections = [
  {
    id: OVERLAYS_SECTION_RISK_RATINGS,
    title: "Risk Ratings",
    contentComp: "MapControlsOverlayRiskRatings",
    mapLayerMetadata: MAP_LAYER_METADATA_RISK_RATINGS, // layer.source === "mapbox-terrain"
  },
];

let mapControlsConstantsSet = false;
export function setMapControlConstants() {
  if (mapControlsConstantsSet) {
    return;
  }

  pointsSections.push(
    ...(hasMyIncidentsAccess()
      ? [
          {
            id: POINTS_SECTION_MY_INCIDENTS,
            title: "My Incidents",
            visible: false,
            visibleDefault: false,
            contentComp: "MapControlsPointsMyIncidents",
            mapLayerMetadata: MAP_LAYER_METADATA_MY_INCIDENTS,
            filterLinkPanel: "myIncidents",
          },
        ]
      : [])
  );
  pointsSections.push({
    id: POINTS_SECTION_ASSETS,
    title: "Assets",
    visible: false,
    visibleDefault: false,
    contentComp: "MapControlsPointsAssets",
    mapLayerMetadata: MAP_LAYER_METADATA_ASSETS,
    filterLinkPanel: "assets",
  });

  overlaysSections.push(
    ...(!hasEssentialsAccess()
      ? [
          {
            id: OVERLAYS_SECTION_PULSE,
            title: "Pulse",
            contentComp: "MapControlsOverlayPulse",
            mapLayerMetadata: MAP_LAYER_METADATA_PULSE, // layer["source-layer"].indexOf("Pulse") >= 0
          },
        ]
      : []),
    ...(hasPowerOutageAccess()
      ? [
          {
            id: OVERLAYS_SECTION_POWER_OUTAGE,
            title: "Power Outage",
            contentComp: "MapControlsOverlayPowerOutage",
            mapLayerMetadata: MAP_LAYER_METADATA_POWER_OUTAGE,
          },
        ]
      : [])
  );
  mapControlsConstantsSet = true;
}

export const POINTS_SECTIONS = pointsSections;
export const OVERLAYS_SECTIONS = overlaysSections;

// Default selected section for overlays, available to all access group
export const OVERLAYS_SECTIONS_SELECTED_TYPE_DEFAULT = undefined; //OVERLAYS_SECTIONS[0].id

export const EXTERNAL_SECTIONS_SELECTED_ID_DEFAULT = undefined;

export const EXTERNAL_SOURCES_TILES = "TILES";
export const EXTERNAL_SOURCES_WMS = "WMS";
